import CurveBackground from './CurveBackground';

export default CurveBackground;
